import { Component, Input, OnInit } from '@angular/core';

import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { QuickStatsComponent } from '../quick-stats/quick-stats.component';

@Component({
	selector: 'app-ctv-quickstats-r7',
	styleUrls: ['./ctv-quickstats-r7.component.css'],
	templateUrl: './ctv-quickstats-r7.component.html'
})
export class CtvQuickstatsR7Component extends QuickStatsComponent implements OnInit {
	@Input() legend: any;

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.legend = JSON.parse(decodeURI(this.legend));
	}

	processResponseData(response: any): void {
		const impressions = UtilityService.isUndefinedOrNull(response[0].impressions) ? 0 : response[0].impressions;
		const completions = UtilityService.isUndefinedOrNull(response[0].completions) ? 0 : response[0].completions;
		const totalVisits = UtilityService.isUndefinedOrNull(response[0].total_visits) ? 0 : response[0].total_visits;
		const viewThroughs = UtilityService.isUndefinedOrNull(response[0].view_throughs) ? 0 : response[0].view_throughs;
		const clicks = UtilityService.isUndefinedOrNull(response[0].clicks) ? 0 : response[0].clicks;
		const householdVisits = UtilityService.isUndefinedOrNull(response[0].household_visits)
			? 0
			: response[0].household_visits;

		const completionsPercentage = UtilityService.isUndefinedOrNull(response[0].completions_percent)
			? UtilityService.isUndefinedOrNull(response[0].completions_rate)
				? '-- '
				: parseFloat(response[0].completions_rate).toFixed(2)
			: parseFloat(response[0].completions_percent).toFixed(2);
		const visitsPercentage = UtilityService.isUndefinedOrNull(response[0].total_visits_percent)
			? '-- '
			: parseFloat(response[0].total_visits_percent).toFixed(2);
		const viewThroughsPercentage = UtilityService.isUndefinedOrNull(response[0].view_throughs_percent)
			? '-- '
			: parseFloat(response[0].view_throughs_percent).toFixed(2);
		const clicksPercentage = UtilityService.isUndefinedOrNull(response[0].clicks_percent)
			? '-- '
			: parseFloat(response[0].clicks_percent).toFixed(2);

		this.quickStatsData = {
			clicks,
			clicksPercentage,
			completions,
			completionsPercentage,
			impressions,
			totalVisits,
			viewThroughs,
			viewThroughsPercentage,
			visitsPercentage,
			householdVisits
		};
	}
}
